/* unplugin-vue-components disabled */import { render } from "./onboarding.vue?vue&type=template&id=4695798a&scoped=true"
import script from "./onboarding.vue?vue&type=script&lang=js"
export * from "./onboarding.vue?vue&type=script&lang=js"

import "./onboarding.vue?vue&type=style&index=0&id=4695798a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4695798a"],['__file',"src/pages/onboarding/onboarding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4695798a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4695798a', __exports__)) {
    api.reload('4695798a', __exports__)
  }
  
  module.hot.accept("./onboarding.vue?vue&type=template&id=4695798a&scoped=true", () => {
    api.rerender('4695798a', render)
  })

}


export default __exports__